import { Button } from 'foundations-components/transitional/components/Button';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import trackedProp from './trackedProp';
export const TrackedButton = trackedProp(Button, 'onClick');
export const TrackedLoadingButton = trackedProp(LoadingButton, 'onClick');
export const TrackedDialogCloseButton = trackedProp(DialogCloseButton, 'onClick');